import { render, staticRenderFns } from "./SalarySettlements.vue?vue&type=template&id=1243ec4e"
import script from "./SalarySettlements.vue?vue&type=script&lang=js"
export * from "./SalarySettlements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports